import { render } from "./DeniedRequests.vue?vue&type=template&id=324571f2"
import script from "./DeniedRequests.vue?vue&type=script&lang=js"
export * from "./DeniedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__